import { FC } from 'react'
import {
  StyleAccordionItemTitleWrapper,
  StyleAccordionItemWrapper,
  StyleAccoridionItemTitle,
  StyleAccordionItemContentWrapper,
  StyleAccordionItemDescription,
  StyleAccordionIconWrapper,
} from './style'
import Svg from '../svg'
interface ItemProps {
  item?: any
  title?: string
  description?: string
  isActive?: boolean
  index?: number
}
const Item: FC<ItemProps> = ({
  item,
  title,
  description,
  isActive,
  index,
  ...restProps
}) => {
  return (
    <StyleAccordionItemWrapper {...restProps}>
      <StyleAccordionItemTitleWrapper data-cross-index={index}>
        <StyleAccoridionItemTitle>{title}</StyleAccoridionItemTitle>
        <StyleAccordionIconWrapper isActive={isActive}>
          {!!isActive ? (
            <Svg svg="chervonUp" size={30} color={'black'} />
          ) : (
            <Svg svg="chervonDown" size={30} color={`black`} />
          )}
        </StyleAccordionIconWrapper>
      </StyleAccordionItemTitleWrapper>
      {!!isActive && (
        <>
          {!!item?.renderComponent ? (
            item?.renderComponent(item)
          ) : (
            <StyleAccordionItemContentWrapper>
              <StyleAccordionItemDescription>
                {description}
              </StyleAccordionItemDescription>
            </StyleAccordionItemContentWrapper>
          )}
        </>
      )}
    </StyleAccordionItemWrapper>
  )
}

export default Item
